export default __webpack_public_path__ + "static/media/detail_main_img_2.0bc83516.png";